// extracted by css-extract-rspack-plugin
export default {"chart":"srTqIUOmnhk8Uvqf"};